import styled from 'styled-components'

export const StickyFooter = styled.footer`
  background-color: ${({ theme }) => theme.headerBackground};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 25;
`
